(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('SubmitReportDialogController', SubmitReportDialogController);

    SubmitReportDialogController.$inject = ['$mdDialog', '$q', '$timeout', 'emailRequired', 'lenderName', 'contact'];

    function SubmitReportDialogController($mdDialog, $q, $timeout, emailRequired, lenderName, contact) {
        var vm = this;
        var copiedTimers = {};

        vm.emailRequired = emailRequired;
        vm.lenderName = lenderName;
        vm.contactName = contact ? [contact.firstName, contact.lastName].filter(Boolean).join(' ') : null;
        vm.contactEmail = contact ? contact.emailAddress : null;
        vm.ccEmail = 'appraisals@valueconnect.ca';
        vm.acknowledged = false;
        vm.copied = {};

        vm.copy = copy;
        vm.submit = submit;
        vm.cancel = cancel;

        function copy(key) {
            copyText(key === 'cc' ? vm.ccEmail : vm.contactEmail).then(function() {
                vm.copied[key] = true;
                $timeout.cancel(copiedTimers[key]);
                copiedTimers[key] = $timeout(function() {
                    vm.copied[key] = false;
                }, 1600);
            });
        }

        function copyText(text) {
            if (navigator.clipboard && window.isSecureContext) {
                return $q.when(navigator.clipboard.writeText(text));
            }
            var textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            return $q.when();
        }

        function submit() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();
